import Model from './Model';

export default class Toldo90 extends Model {
    boot() {
        super.boot();

        this.modelName = 'toldo-90';
        this.config.customRoutes = [
            {
                name: 'data',
                type: 'get',
                url: 'data/t-90'
            },
            {
                name: 'models',
                type: 'get',
                url: 'models/t-90'
            },
            {
                name: 'update',
                type: 'patch',
                url: 'toldo-90/{id}/'
            }
        ]
    }

    data = (params) => {
        return this.withParams(params).route('data');
    };

    models = (params) => {
        return this.withParams(params).route('models');
    };

    update = (id, params) => {
        return this.withParams(params).route('update', { id });
    };
}
